/* ============================================================
   Face2Face Fun - theme.js
   Handles: cart AJAX, quick-add, wishlist, nav scroll,
            categories dropdown, mobile menu
   ============================================================ */

(function() {
  'use strict';

  /* -- Cart Count Update -- */
  function updateCartCount(count) {
    var countEls = document.querySelectorAll('.cart-count');
    countEls.forEach(function(el) { el.textContent = count; });
  }

  /* -- Fetch Cart -- */
  function fetchCart() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { updateCartCount(cart.item_count); })
      .catch(function(err) { console.error('Cart fetch error:', err); });
  }

  /* -- Quick Add to Cart -- */
  function initQuickAdd() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.product-card__add');
      if (!btn) return;

      var variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.textContent = '...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        fetchCart();
        btn.textContent = 'v';
        btn.style.background = '#4CAF50';
        setTimeout(function() {
          btn.textContent = '+';
          btn.style.background = '';
          btn.disabled = false;
        }, 1500);
      })
      .catch(function() {
        btn.textContent = '+';
        btn.disabled = false;
      });
    });
  }

  /* -- Buy Now -- */
  function initBuyNow() {
    var buyBtn = document.getElementById('buy-now-btn');
    if (!buyBtn) return;

    buyBtn.addEventListener('click', function() {
      var variantInput = document.getElementById('variant-id-input');
      var qtyInput     = document.getElementById('qty-input');
      if (!variantInput) return;

      var id  = variantInput.value;
      var qty = qtyInput ? qtyInput.value : 1;

      fetch('/cart/clear.js', { method: 'POST' })
        .then(function() {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: id, quantity: parseInt(qty) })
          });
        })
        .then(function() {
          window.location.href = '/checkout';
        })
        .catch(function(err) { console.error('Buy now error:', err); });
    });
  }

  /* -- Sticky Nav Shadow -- */
  function initStickyNav() {
    var header = document.querySelector('.site-header');
    if (!header) return;

    window.addEventListener('scroll', function() {
      if (window.scrollY > 10) {
        header.style.boxShadow = '0 2px 12px rgba(0,0,0,0.06)';
      } else {
        header.style.boxShadow = 'none';
      }
    }, { passive: true });
  }

  /* ============================================================
     CATEGORIES DROPDOWN
     Handles: click-to-toggle, keyboard (Enter/Space/Escape),
              close when clicking outside
     CSS handles the hover-open behavior via :hover.
     JS adds the .open class for click/keyboard support.
  ============================================================ */
  function initDropdowns() {
    var dropdownItems = document.querySelectorAll('.has-dropdown');
    if (!dropdownItems.length) return;

    dropdownItems.forEach(function(item) {
      var trigger = item.querySelector('.nav-dropdown__trigger');
      var dropdown = item.querySelector('.nav-dropdown');
      if (!trigger || !dropdown) return;

      /* Click: toggle .open class */
      trigger.addEventListener('click', function(e) {
        /* Only intercept click on the trigger itself (not navigating away) */
        var isOpen = item.classList.contains('open');

        /* Close all other dropdowns first */
        dropdownItems.forEach(function(other) {
          if (other !== item) {
            other.classList.remove('open');
            var otherTrigger = other.querySelector('.nav-dropdown__trigger');
            if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
          }
        });

        if (isOpen) {
          item.classList.remove('open');
          trigger.setAttribute('aria-expanded', 'false');
        } else {
          /* Prevent navigation when just opening the dropdown */
          e.preventDefault();
          item.classList.add('open');
          trigger.setAttribute('aria-expanded', 'true');
          /* Focus first item for keyboard users */
          var firstLink = dropdown.querySelector('a');
          if (firstLink) firstLink.focus();
        }
      });

      /* Keyboard: Escape closes */
      item.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          item.classList.remove('open');
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus();
        }
      });
    });

    /* Close when clicking outside any dropdown */
    document.addEventListener('click', function(e) {
      dropdownItems.forEach(function(item) {
        if (!item.contains(e.target)) {
          item.classList.remove('open');
          var trigger = item.querySelector('.nav-dropdown__trigger');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  /* ============================================================
     MOBILE MENU
     Opens/closes the full-screen drawer.
     Includes accordion for Categories sub-links.
  ============================================================ */
  function initMobileMenu() {
    var toggle   = document.getElementById('mobile-menu-toggle');
    var menu     = document.getElementById('mobile-menu');
    var overlay  = document.getElementById('mobile-menu-overlay');
    var closeBtn = document.getElementById('mobile-menu-close');

    if (!toggle || !menu) return;

    function openMenu() {
      menu.classList.add('open');
      menu.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden'; /* prevent scroll behind drawer */
    }

    function closeMenu() {
      menu.classList.remove('open');
      menu.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', function() {
      if (menu.classList.contains('open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    if (overlay)  overlay.addEventListener('click', closeMenu);

    /* Escape key closes menu */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && menu.classList.contains('open')) {
        closeMenu();
        toggle.focus();
      }
    });

    /* Mobile Categories Accordion */
    var accordionTriggers = menu.querySelectorAll('.mobile-menu__accordion-trigger');
    accordionTriggers.forEach(function(btn) {
      var targetId = btn.getAttribute('aria-controls');
      var subList  = targetId ? document.getElementById(targetId) : null;
      if (!subList) return;

      btn.addEventListener('click', function() {
        var isOpen = subList.classList.contains('open');

        /* Close all other accordions */
        accordionTriggers.forEach(function(other) {
          if (other !== btn) {
            var otherId = other.getAttribute('aria-controls');
            var otherList = otherId ? document.getElementById(otherId) : null;
            if (otherList) {
              otherList.classList.remove('open');
              other.setAttribute('aria-expanded', 'false');
              otherList.setAttribute('aria-hidden', 'true');
            }
          }
        });

        if (isOpen) {
          subList.classList.remove('open');
          btn.setAttribute('aria-expanded', 'false');
          subList.setAttribute('aria-hidden', 'true');
        } else {
          subList.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
          subList.setAttribute('aria-hidden', 'false');
        }
      });
    });
  }

  /* -- Newsletter form -- */
  function initNewsletter() {
    var newsletterBtns = document.querySelectorAll('.footer-newsletter .btn');
    newsletterBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = this.previousElementSibling;
        if (!input || !input.value || !input.value.includes('@')) {
          input.style.borderColor = '#E8440A';
          return;
        }
        this.textContent = 'Thanks!';
        this.style.background = '#4CAF50';
        input.value = '';
        input.style.borderColor = '';
      });
    });
  }

  /* -- Init -- */
  document.addEventListener('DOMContentLoaded', function() {
    fetchCart();
    initQuickAdd();
    initBuyNow();
    initStickyNav();
    initDropdowns();
    initMobileMenu();
    initNewsletter();
  });

})();